import styled from 'styled-components';
import { COLOR_LINK } from 'constants/colors';

export const ActionButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_LINK};
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
